import { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { AbilityBuilder } from '@casl/ability';
import { googleAuthCallback } from 'apis/users.api';
import LanguageSelect from 'components/LanguageSelect';
import defineRules from 'utils/casl/defineRules';
import { AbilityContext } from 'components/Can';

import TokenService from 'utils/axios/token.axios';
import { mapError } from 'utils/func';

function updateAbility(ability) {
  const { can, cannot, rules } = new AbilityBuilder();
  defineRules(can, cannot);

  ability.update(rules);
}

function GoogleAuthCallback() {
  // #region Data
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const navigate = useNavigate();
  const { search } = useLocation();
  const [message, setMessage] = useState('');

  const { refetch, isLoading, isError, error } = useQuery(
    ['googleAuthCallback', search],
    () => googleAuthCallback(search),
    {
      enabled: false,
      onSuccess: (res) => {
        const userResponse = { ...res.data };

        if (!userResponse.isSuccess) {
          TokenService.removeUser();
          setMessage(userResponse.message);
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        } else {
          delete userResponse.status;
          delete userResponse.isSuccess;
          delete userResponse.message;
          TokenService.setUser(userResponse);
          updateAbility(ability);
          navigate('/');
        }
      },
    }
  );
  // #endregion Data

  // #region Event
  useEffect(() => {
    if (search) {
      refetch();
    }
  }, [search]);

  // #endregion Event

  return (
    <>
      <div className="p-4 fixed right-0">
        <LanguageSelect />
      </div>
      <div className="flex align-items-center justify-content-center" style={{ height: '80vh' }}>
        <div
          className="surface-card p-4 shadow-2 border-round w-full lg:w-6"
          style={{ maxWidth: '400px' }}
        >
          <div className="text-center mb-5">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="hyper"
              height={50}
              className="mb-3"
            />
            <div className="text-900 text-3xl font-medium my-3">
              {isLoading && <p className="text-green-500">{t('googleCallback.pleaseWait')}</p>}
              {isError && <p className="text-red-400">{mapError(t, error)}</p>}
              {message && <p className="text-red-400">{t(`errorMessage.${message}`)}</p>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GoogleAuthCallback;
